import { useEffect, useState } from 'react';

export type GeolocationError = GeolocationPositionError | { code: -1, message: string };
export const usePosition = () => {
  const [position, setPosition] = useState<GeolocationPosition | null>(null);
  const [error, setError] = useState<GeolocationError | null>(null);

  // callbacks will go here...
  useEffect(() => {
    const geo = navigator.geolocation;
    if (!geo) {
      setError({ code: -1, message: 'Geolocation is not supported' });
      return;
    }
    const onChange = (pos: GeolocationPosition) => {
      // Plain-object clone of the GeolocationPosition (the browser instance
      // can't be mutated/spread directly in some agents). We omit `toJSON`
      // — the consumer reads timestamp/coords only.
      const clone = {
        timestamp: pos.timestamp,
        coords: pos.coords,
      } as GeolocationPosition;
      setPosition(clone);
      setError(null);
    };
    const onError = (err: GeolocationPositionError) => {
      setError(err);
    };
    const watcher = geo.watchPosition(onChange, onError);
    geo.getCurrentPosition(onChange, onError);
    // eslint-disable-next-line consistent-return
    return () => { geo.clearWatch(watcher); };
  }, [setPosition, setError]);
  return { ...position, error, isLoading: !position && !error };
};
